import React from 'react';

import { URLS } from 'rebook/apps/base/constants';
import VerticalBookCardList from 'rebook/apps/books/components/VerticalBookCardList';
import numberWithSpace from 'rebook/apps/utils/text/numberWithSpace';

import LandingContentContainer from '../LandingContentContainer';


const AllAudioBooks = ({ audioBooks, audioBooksCounter }) => {
  return (
    <div className="billetContainerNoOverflow">
      <div className="billetContainerWrapper">
        <LandingContentContainer
          link={URLS.catalogAudiobooks}
          title="Неудобно читать – слушайте"
          linkText="Все аудиокниги" />
        <p>{`Более ${numberWithSpace(audioBooksCounter)} аудиокниг для взрослых и детей`}</p>
      </div>
      <VerticalBookCardList bookList={audioBooks && audioBooks.books} />
    </div>
  );
};

export default AllAudioBooks;
